import React from 'react';
import { I18n } from '@aws-amplify/core';
import { Text } from '@/components/Typography';

export function Title() {
	const text: string = 'Check the tool for conducting risk assessments';
	return <Text strong>{I18n.get(text)}:</Text>;
}
